import BaseUI from "./BaseUI";
import { UIStates, UIModes } from "./UIStates";
import InstanceFactory from "../../src/factories/InstanceFactory";
import AbstractPopup from "./popups/AbstractPopup";
import { UIUpdateEvent } from "./UIUpdateEvents";
import ConsoleUtil from '../utils/ConsoleUtil';
import GameModel from "../model/GameModel";
import KeyboardManager, { Key } from "../utils/KeyboardManager";
import { Commands } from "../commands/CommandEnum";
import CommandManager from "../commands/CommandManager";
import App from "../App";
import { Tween } from "./../Tween";

class UIController {
    public components: Map<string, BaseUI | AbstractPopup> = new Map();
    protected uiMap: Map<string, FunctionConstructor> = new Map();
    public errorPopup: AbstractPopup;
    public messagePopup: AbstractPopup;
    protected mode:UIModes | string;
    protected state:UIStates | string;

    public create() {
        this.components.forEach(el => {
            el.create();
        });
        this.errorPopup = this.components.get('errorPopup') as AbstractPopup;
        this.messagePopup = this.components.get('messagePopup') as AbstractPopup;
    }

    public updateFields(event?: UIUpdateEvent, props?: any) {
        this.components.forEach(el => {
            el.update(event ,props);
        });
    }

    public setMode(mode:UIModes | string) {
        // ConsoleUtil.logWithColor("[UI] Set MODE: " + mode, 0x34eb8c);
        this.mode = mode;
    }

    public getCurrentMode() {
        return this.mode;
    }

    public getCurrentState() {
        return this.state;
    }

    public setState(state: UIStates | string) {
        // ConsoleUtil.logWithColor("[UI] Set STATE: " + state + " (mode: " + (this.mode || "DEFAULT") + ")", 0xfafa82);
        this.state = state;
        this.components.forEach(el => {
            el.setState(state,this.mode);
        });
    }

    public toggleComponent(name: string, arg?) {
        let component = this.components.get(name);
        if (component instanceof AbstractPopup) {
            component.toggle(arg);
            component.setState(this.state,this.mode);
        }
    }

    public isComponentHidden(name: string): boolean {
        if (!this.components.has(name)) {
            return true;
        }
        let component = this.components.get(name);
        return component.isHidden;
    }

    public setComponent(name:string, component: BaseUI | AbstractPopup) {
        this.components.set(name, component)
    }

    // TODO not sure this is the right place
    public addTurboListener() {
        if (GameModel.alowSpaceToSkipSpin()) {
            document.addEventListener("visibilitychange", this.handleVisibilityChange.bind(this));
            KeyboardManager.onKey("pressed", Key.SPACE, this.toggleTurbo, this);
            KeyboardManager.onKey("released", Key.SPACE, this.toggleTurbo, this);
        }
    }

    public removeTurboListener() {
        if (GameModel.alowSpaceToSkipSpin()) {
            KeyboardManager.offKey("pressed", Key.SPACE, this.toggleTurbo, this);
            KeyboardManager.offKey("released", Key.SPACE, this.toggleTurbo, this);
        }
    }
    private handleVisibilityChange() {
        if (!document.hidden && GameModel.alowSpaceToSkipSpin()) {
            const keyupEvent = new KeyboardEvent('keyup', {
                key: ' ',
                code: 'Space',
                bubbles: true,
                cancelable: true,
              });
              
              // Dispatch the event on a target element or document
              document.dispatchEvent(keyupEvent);
        }
    }

    public preInitializeComponents() {
        this.components.forEach(component => {
            component.preInitialize(true);
        });

        if (GameModel.isMobile(true)) {
            // Make sure the first orientation change
            // will preinitialize the updated components.
            const callback = function() {
                this.components.forEach(component => {
                    component.preInitialize(false);
                });
                window.removeEventListener("orientationchange", callback);
            }.bind(this);

            window.addEventListener("orientationchange", callback);
        }
    }

    protected turboDelay:Tween;
    protected toggleTurbo() {
        if(this.turboDelay && this.turboDelay.progress < 1) {
            this.turboDelay.kill();
            this.turboDelay = null;
        } else {

            this.turboDelay = Tween.delayedCall(0.2, () => {
                CommandManager.execute(Commands.TOGGLE_SPACE_TURBO_SPIN);
            });
            //App.timeline.add(this.turboDelay, App.timeline.time);

        }
    }


}

export default new UIController();
